import React from 'react'
import { useLocalstorageState, useOutsideClick } from 'rooks'
import { useFeature } from '@core/Utils/hooks/useFeature'

export const useShareToBetLoopTooltip = (tooltipStorageKey: string, isEnabled = true) => {
  const shareButtonRef = React.useRef<HTMLButtonElement>(null)
  const shareButtonSeenCountRef = React.useRef(0)

  const [isShareTooltipVisible, setIsShareTooltipVisible] = React.useState(false)

  const isBetLoopFeatureActive = useFeature('content-hub-follow-me')

  const [shareButtonSeenCount, setShareButtonSeenCount] = useLocalstorageState(tooltipStorageKey, 0)
  shareButtonSeenCountRef.current = shareButtonSeenCount

  React.useEffect(() => {
    if (isBetLoopFeatureActive && isEnabled && shareButtonSeenCountRef.current < 2) {
      setIsShareTooltipVisible(true)
      const next = Math.min(2, shareButtonSeenCountRef.current + 1)
      setShareButtonSeenCount(next)
    }
  }, [setShareButtonSeenCount, isEnabled, isBetLoopFeatureActive])

  const handleDismissShareTooltip = () => {
    setIsShareTooltipVisible(false)
  }

  useOutsideClick(shareButtonRef, () => {
    if (isShareTooltipVisible) handleDismissShareTooltip()
  })

  const onShareButtonClick = React.useCallback(() => {
    setShareButtonSeenCount(2)
    setIsShareTooltipVisible(false)
  }, [setShareButtonSeenCount])

  return { shareButtonRef, onShareButtonClick, handleDismissShareTooltip, isShareTooltipVisible }
}
